<template>
    <svg
        :class="[direction]"
        width="13.5px"
        height="8.5px"
    >
        <path fill-rule="evenodd" stroke="rgb(99, 103, 114)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="none"  d="M12.500,1.246 L6.500,7.500 L0.502,1.246 "/>
    </svg>
</template>
<script>
export default {
    props: {
        direction: {
            type: String,
            default: 'down'
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
svg
    transition: transform .625s
    will-change: transform
    &.left
        transform: rotate(90deg)
    &.right
        transform: rotate(-90deg)
    &.top
        transform: rotate(180deg)
// path
//     fill: #636772
</style>
